import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dental/frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingNav"] */ "/var/www/dental/frontend/src/components/marketing/MarketingNav.tsx");
